import { useQuery } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { queryClient } from '@/api/react-query'
import { userPathKey } from '@/helpers'
import { UserProfile } from '@/types'

export async function readUserProfile() {
  const response = await httpClient('user-manager').get<UserProfile>(
    `/v1/user/${userPathKey()}`,
  )

  const data = response.data

  localStorage.setItem('user-profile', JSON.stringify(data))

  return data
}

export function useReadUserProfile() {
  return useQuery({
    queryKey: ['user-profile'],
    queryFn: readUserProfile,
    staleTime: 0,
  })
}

export function refreshUserProfile() {
  return queryClient.fetchQuery({
    queryKey: ['user-profile'],
    queryFn: readUserProfile,
    staleTime: 0,
  })
}
